import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducers from './store/reducers';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import 'bootstrap/dist/css/bootstrap.min.css';
// import { createMuiTheme } from '@material-ui/core';

// const themes = createMuiTheme({
//   palette: {
//     primary: {
//       main: '#008000',
//     },
//     secondary: {
//       main: '#f44336',
//     },
//   },
// });
const store = createStore(reducers, applyMiddleware(thunk))

ReactDOM.render(
  <Provider store ={store}>

    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
